import { Button, Col, Divider, Radio, Row } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrack } from "../../store/apis/tracks";
import "./index.scss";
import { subscribeTrack } from "../../store/apis/users";
import { useNavigate } from "react-router-dom";

function Payment() {
  const [paymentGetway, setPaymentGetway] = useState("");
  const [pendingStatus, setPendingStatus] = useState(false);
  const track = useSelector((state) => state.tracks.track);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const trackId = window.location.pathname.split("/")[2];
    dispatch(getTrack(trackId));
  }, []);

  const onChangePaymentGetway = (event) => {
    const value = event.target.value;
    setPaymentGetway(value);
  };

  const handelSubmitPaymentSubsicription = () => {
    if (user && user?._id && track && track?._id) {
      const trackId = track?._id;
      const checkTrack = user?.paidTracks?.find(
        (item) => item.trackId == trackId
      );
      if (!checkTrack && user && trackId && paymentGetway) {
        const params = {
          trackId,
          paymentGetway,
        };
        dispatch(subscribeTrack(params));
        navigate(`/track/${track?._id}`);
      }
    }
  };

  useEffect(() => {
    const trackStatus = user?.paidTracks?.find(
      (item) => item.trackId === track?._id
    )?.status;
    if (trackStatus == "pending") {
      setPendingStatus(true);
    } else if (trackStatus != "paid") {
      setPendingStatus(false);
    } else {
      setPendingStatus(false);
    }
  }, [user]);

  return (
    <div className="payment-container">
      <div className="payment-card">
        <Row>
          {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}> */}
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className="about-course-container">
              {!pendingStatus ? (
                <div className="about-course-card">
                  <div className="about-course-card-title">
                    <h2> {track?.title} : شهادة احترافية </h2>
                    <span> بواسطة قولانسر </span>
                  </div>
                  <Divider />
                  <div className="payment-details">
                    <h3> لا يوجد التزام. يمكنك الإلغاء في أي وقت. </h3>
                    <div className="payment-details-box">
                      <span> اشتراك دائم </span>
                      <span> مزايا دائمة </span>
                    </div>
                    <div className="payment-details-box">
                      <span> مجموع الدفع USD </span>
                      <span> ${track?.price} </span>
                    </div>
                  </div>
                  <Divider />
                  <div className="payment-getways">
                    <h2>
                      بوابات الدفع المتوفرة / اختار أحد بوابات الدفع للتواصل معك
                      من قبل الفريق المختص:
                    </h2>
                    <Radio.Group
                      onChange={onChangePaymentGetway}
                      value={paymentGetway}
                    >
                      <Radio value="online">
                        <div className="payment-getway-box">
                          <span> أونلاين مع محفظة جوال </span>
                        </div>
                      </Radio>
                      <Radio value="ofline">
                        <div className="payment-getway-box">
                          <span>
                            {" "}
                            كاش في مكتبنا الرئيسي - غزة - مقابل معتوق{" "}
                          </span>
                        </div>
                      </Radio>
                      <Radio value="none">
                        <div className="payment-getway-box">
                          <span> لا خيار حالياً</span>
                        </div>
                      </Radio>
                    </Radio.Group>
                  </div>
                  <div className="payment-button">
                    <Button
                      type="primary"
                      disabled={!paymentGetway}
                      onClick={handelSubmitPaymentSubsicription}
                    >
                      طلب اشتراك
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="pending-ui-container">
                  <div className="pending-ui-details">
                    <h3> طلبك قيد المراجعة... </h3>
                    <span>
                      سيتم التواصل معك في أقرب وقت, للتواصل +970 599 093 924
                    </span>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => navigate(`/track/${track?._id}`)}
                  >
                    العودة الى المسار
                  </Button>
                </div>
              )}
            </div>
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="payment-head-section">test</div>
          </Col> */}
        </Row>
      </div>
    </div>
  );
}

export default Payment;
